import {Component} from 'react';
import h from 'react-hyperscript';
import './Login.scss';
import {h2, p} from 'Components/Typography/Typography';
import content from 'Assets/data/globals.json';

class Login extends Component {
  render() {
    return (
      h('div', {
        className: 'container flex--wrap-all',
        id: 'login',
      }, [
        h(h2, {
          key: 'error-title__key',
          className: 'text--grey text--center',
        }, content.login.title),
        h(p, {
          className: 'text--center text--grey padding-bottom--md',
        }, content.login.desc),
        h(p, {
          className: 'text--center text--grey padding-bottom--md',
        }, [
          content.login.disclaimer.copy,
          h('a', {
            href: content.login.disclaimer.link.href,
            alt: content.login.disclaimer.link.href,
            target: '_blank',
          }, content.login.disclaimer.link.text),
        ]),
      ])
    );
  }
}

export default Login;
